import mapboxgl from "mapbox-gl";
import React, { useContext, useEffect, useState } from "react";
import { MapContext } from "../../contexts/map";

interface MouseOverlayProps {
  position?: "top-left" | "top-right" | "bottom-left" | "bottom-right";
}

const MouseOverlay: React.FC<MouseOverlayProps> = ({
  position = "bottom-right",
}) => {
  const { map, setMap } = useContext(MapContext);
  const [coordinates, setCoordinates] = useState<number[] | null>(null);

  useEffect(() => {
    const setMousePosition = (e: mapboxgl.MapMouseEvent) => {
      setCoordinates(e.lngLat.toArray());
    };

    if (map) {
      map.on("mousemove", setMousePosition);
      setMap(map);
    }

    return () => {
      if (map) {
        map.off("mousemove", setMousePosition);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={`flex items-center bg-white border rounded-lg p-1 w-2/5 z-10 absolute ${position
        .split("-")
        .map((s) => s + "-0")
        .join(" ")}`}
    >
      <span className="flex w-full text-xs text-text  justify-evenly">
        <span className="w-1/2 m-1 break-words">
          Longitude: {coordinates ? coordinates[0].toFixed(6) : ""}
        </span>
        <span className="w-1/2 m-1 break-words">
          Latitude: {coordinates ? coordinates[1].toFixed(6) : ""}
        </span>
      </span>
    </div>
  );
};

export default MouseOverlay;
